<loading [visible]="loading() || saving()"></loading>

@if (!loading()) {
<app-custom-modal [customTitle]="(id ? 'Editar' : 'Nuevo') + ' rol'" (closeFunction)="closeFunction.emit()"
    (acceptFunction)="save()">
    <form [formGroup]="form" class="space-y-4">
        <custom-input [autofocus]="true" label="Nombre" type="text"
            [formControlItem]="form.get('name')"></custom-input>
        <custom-input label="Descripción" type="text"
            [formControlItem]="form.get('description')"></custom-input>
    </form>
</app-custom-modal>
}
